import {of} from 'rxjs';
import {take, timeout, catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {AuthService} from "../services/AuthService";
import {defer, Observable, Subscription} from "rxjs";
import {NotificationService} from "../services/common/NotificationService";
import {BsModalRef} from "ngx-bootstrap/modal";
import {AuthenticatedUsersOnlyModalComponent} from "../areas/modals/authenticated-users-only-modal/authenticated-users-only-modal.component";
import {SiteConfigurationService} from "../services/SiteConfigurationService";
import {NGXLogger} from "ngx-logger";
import {PublishedResourceRepository} from "../services/repository/PublishedResourceRepository";
import {RoutingService} from "../services/RoutingService";
@Injectable({
	providedIn: 'root',
})
/**
 * Specifies whether a Draft can be edited or not
 */
export class PublicAccessBlockGuard implements CanActivate {

	private bsModalRef:BsModalRef;
	private subscriptions:Array<Subscription> = [];
	private next:ActivatedRouteSnapshot;
	private state:RouterStateSnapshot;

	constructor(private authService:AuthService,
				private notificationService:NotificationService,
				private publishedResourceRepository:PublishedResourceRepository,
				private router:Router,
				private routingService:RoutingService,
				private siteConfigurationService:SiteConfigurationService,
				protected logger:NGXLogger) {
	}

	public canActivate(next:ActivatedRouteSnapshot, state:RouterStateSnapshot):Observable<boolean> {
		console.info("PublicAccessBlockGuard::canActivate");
		this.next = next;
		this.state = state;
		let self = this;
		return defer(async function () {
			console.info("PublicAccessBlockGuard::canActivate::async function ()");
			let shouldBlockAccess:boolean = self.siteConfigurationService.siteConfiguration.loginRequiredForSiteAccess;
			if (!shouldBlockAccess) {
				console.info("Not blocking access based on site access variable");
				return true;
			}

            await self.authService.checkIfLoggedIn();
            const isPublic = self.authService.currentUser ? false : await self.checkPublicResource(next.params['resourceId']);
            return self.finishUpEitherWay(isPublic, next, state);
		});
	}

	public finishUpEitherWay(isAPublicResource:boolean, next:ActivatedRouteSnapshot, state:RouterStateSnapshot):boolean {
		let isAUser:boolean = this.authService.currentUser != null;
		let self = this;
		if (isAUser) {
			console.info(`Welcome in ${this.authService.currentUser.guid}!`);
		} else if (!isAUser && isAPublicResource) {
			console.error("Hawt dog.  You got some access to a waihona resource without registering or logging in.");
		} else {
			console.error("It is invalid for anonymous user to access the resource without being registered.");
			if (this.routingService.getPreviousUrl() == undefined) {
				this.router.navigateByUrl("/resources", {skipLocationChange:false});
				console.info("First navigation and not allowed..so navigating to location page.");
				console.log("This: " + this + ", self: " + self);

			}
			console.log("this: " + this.constructor.name);
			this.bsModalRef = this.notificationService.displayModal(AuthenticatedUsersOnlyModalComponent, this);
		}

		return isAUser || isAPublicResource;
	}

    public async checkPublicResource(resourceGuid:string):Promise<boolean> {
        const resource = await this.publishedResourceRepository.get$(resourceGuid).pipe(
            take(1), timeout(10000), catchError(() => of(null))
        ).toPromise();
        return resource?.resourceSubmission?.configuration?.allowPublicAccess === true;
    }

	public clearSubscriptions():void {
		while (this.subscriptions.length > 0) {
			let s:Subscription = this.subscriptions.pop();
			s.unsubscribe();
		}

	}
	public destroyModal():void {
		this.bsModalRef.hide();
		delete this.bsModalRef;
	}

	public onClickLogin():void {
		console.info("Clicked Login");
		this.authService.login(this.state.url);
		this.destroyModal();
	}
	public onClickRegistration():void {
		console.info("Clicked Registration");
		this.router.navigate(["/user/register"]);
		this.destroyModal();
	}
	public onClickCancel():void {
		console.info("Clicked Cancel");
		this.destroyModal();
	}
}
